import Zones from './Zones';

export default Zones;
